'use client';

import React from 'react';
import { IconCheckbox, IconCheckboxFilled } from '@repo/svgs';
import { cn } from '@/lib/cn';

export type CheckboxIconProps = {
  checked: boolean;
  className?: string;
};

export function CheckboxIcon({ checked, className }: CheckboxIconProps) {
  const classes = cn('w-4 h-4', checked ? 'icon-accent' : 'icon-secondary', className);
  return checked ? (
    <IconCheckboxFilled className={classes} aria-hidden />
  ) : (
    <IconCheckbox className={classes} aria-hidden />
  );
}

export default CheckboxIcon;
